import React from 'react'
import {currencyFormater} from '../../utils/helpers'
const Minicart = ({color , name , price , amount , image}) => {
    return (
        <article>
            <div className="mini_cart_item">
                <div className="item_image">
                    <img src={image} alt={name} />
                </div>
                <div className="item_details">
                    <h3>{name}</h3>
                    <span style ={{backgroundColor:color}} className='item_color'></span>
                </div>
                <div className="item_price">{currencyFormater(price*amount)}</div>
                
            </div>
        </article>
    )
}

export default Minicart
